<template>
  <v-dialog v-model="dialog" persistent max-width="800px" >
    <template v-slot:activator="{ on, attrs }">
			<v-btn class="ml-2 app-bar-btn"  color="primary" dark @click.stop="dialog = true" v-bind="attrs" v-on="on">
				<v-icon class="mr-1">mdi-plus</v-icon>
			  社員を追加
			</v-btn>
		</template>
    
    <div class="authority-user">
      <div class="authority-user__box">
        <div class="authority-user__title">
          <h2>権限取得社員追加</h2>
          <v-btn color="primary" dark @click="close()" large><v-icon>mdi-close</v-icon></v-btn>
        </div>
        <v-card>
          <v-form ref="form" v-model="valid" lazy-validation >
            <v-card-text>
              <v-alert v-for="(error, i) in errors" :key="i" border="top" color="red lighten-2" dark>
				       {{ error }}
			        </v-alert>
              <v-container >
                <v-row>
                  <v-col
                    cols="12"
                  >
                  <v-combobox
                    v-model="selected_user"
                    :items="company_users"
                    required
                    :rules="[rules.required]"
                    outlined
                    multiple
                    label="社員名を選択もしくは検索"
                    small-chips
                    chips
                    deletable-chips
                    item-text="full_name"
                    item-value="id"
                    @change="filterSelectedUsers"
                  />
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-row no-gutters class="my-4" justify="center" >
                <v-btn color="secondary" @click="addAuthorityUser()" :dark="isValid" :disabled="!isValid"> 登録する </v-btn>
              </v-row>
            </v-card-actions>
          </v-form>
        </v-card>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import axios from 'axios';
import rules from "../../../helper/rules";
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"


  export default {
    props: {
      company_users: {
        type: Array,
        default: [],
      },
    },

    data() {
      return {
       selected_user:[],
       dialog: false,
       rules: rules,
       valid: false,
       id: this.$route.params["id"],
       errors: []
      }
    },
    

    methods: {
      filterSelectedUsers(items){
        this.selected_user = items.filter((item) => this.company_users.includes(item))
      },

      close(){
        this.selected_user = ""
        this.errors = ""
        this.dialog = false
      },

      addAuthorityUser() {
			const headers = authenticate.setHeader()
			const formData = new FormData()
			if (!this.selected_user.length == 0) {
				this.selected_user.forEach((v) => {
					formData.append("authority_user[user_ids]" + "[]", v.id)
				})
				axios
					.post(`/erp/v1/authorities/${this.id}/authority_users`, formData, { headers })
					.then((res) => {
						this.$store.commit("setFlash", {
							text: "追加しました",
							type: "notice",
						})
						this.close()
						this.$emit("reload")
					})
					.catch((err) => {
						let error = errorHandling.errorResponse(err)
						if (Array.isArray(error)) {
							this.errors = error
						}
					})
        } else {
          this.close()
        }
      }
	  },
    computed: {
      isValid() {
        return this.selected_user.length > 0 
      }
    },
  }
</script>

<style lang="scss" scoped >
  .authority-user {
      border: #09194F solid 2px;
      border-radius: 5px;
    &__box{
      max-width: 800px;
    }
    &__title{
      margin: 0 auto;
      background: #09194F;
      max-width: 800px;
      display: flex;
      justify-content: space-between;
      h2{
        padding: 5px;
        color: #FEFEFE;
        margin-left: 10px;
      }
    }
  }
    
</style>